import { createContext } from "react";
import type { SetSelectedWorkoutLabelsContextType } from "../SelectedWorkoutLabelsProvider.types";

const SetSelectedWorkoutLabelsContext = createContext<SetSelectedWorkoutLabelsContextType | undefined>(undefined);
SetSelectedWorkoutLabelsContext.displayName = "SetSelectedWorkoutLabelsContext";

export default SetSelectedWorkoutLabelsContext;
